export default __webpack_public_path__ + "static/media/icon-checkmark.abaf55a0.svg";